import { __awaiter, __generator, __read } from "tslib";
import { getIvAndEncryptedBuffer } from './InitializationVector';
export function decrypt(toDecryptPlusIv, key) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, iv, toDecrypt, decryptedResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = __read(getIvAndEncryptedBuffer(toDecryptPlusIv), 2), iv = _a[0], toDecrypt = _a[1];
                    return [4 /*yield*/, window.crypto.subtle.decrypt({
                            name: 'AES-GCM',
                            iv: iv,
                            tagLength: 128,
                        }, key, toDecrypt)];
                case 1:
                    decryptedResponse = _b.sent();
                    return [2 /*return*/, decryptedResponse];
            }
        });
    });
}
//# sourceMappingURL=decrypt.js.map